import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private apiUrl = `${environment.glassApiUrl}/v2/session`;

  constructor(private http: HttpClient) {}

  register(): void {
    this.http.post(this.apiUrl, {}).subscribe({
      error: (err) => console.warn('Session registration failed', err),
    });
  }
}
